import { cloneDeep } from '@apollo/client/utilities';
import { forCreate, forDelete, forUpdate } from '../common/entity';
import { EntityInput } from '../common/entity';
import { CustomField, CustomFieldEntityType } from '../custom_field/customField';
import { Contact } from './contact';

export class ContactInput extends Contact implements EntityInput<Contact> {
  forCreate(): CreateContactInput {
    return CreateContactInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      CreateContactInput,
    );
  }

  forUpdate(): UpdateContactInput {
    return UpdateContactInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      UpdateContactInput,
    );
  }

  forDelete(): DeleteContactInput {
    return DeleteContactInput.from(this, DeleteContactInput);
  }

  validate(customFields: Map<string, CustomField>) {
    const mandatoryCustomFields = [...customFields.values()].filter(
      cf => cf.entityType === CustomFieldEntityType.contact && cf.mandatory,
    );

    if (!this.name) return false;
    if (mandatoryCustomFields.some(cf => !this.customFields.get(cf.id)?.value)) return false;

    return true;
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }
}

export class CreateContactInput extends forCreate(Contact) {}

export class UpdateContactInput extends forUpdate(Contact) {}

export class DeleteContactInput extends forDelete(Contact) {}
